export default __webpack_public_path__ + "static/media/mirror.bde70b97.png";